export interface HotItem {
  rank: number;
  title: string;
  tag: "新" | "热" | "沸";
  heat: string;
  trend: "up" | "down" | "flat";
  delay?: string;
}

export interface Category {
  key: string;
  name: string;
  desc: string;
  count: number;
}

export interface Article {
  id: string;
  categoryKey: string;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  views: string;
  minutes: number;
  tag: string;
  image: string;
}

export interface Story {
  id: string;
  kicker: string;
  title: string;
  excerpt: string;
  date: string;
  minutes: number;
  reading: number;
  image: string;
}

export interface Faq {
  q: string;
  a: string;
}

export interface Voice {
  name: string;
  role: string;
  text: string;
}

export const brand = {
  name: "吃瓜黑屋",
  slogan: "热点背后，还有一层。",
  desc: "专注娱乐与大众热点背后的真实脉络、行业演进与人物故事，把热闹看透，也把门道讲清。",
  established: 2021,
};

export const stats = [
  { label: "深度专题", value: "128+" },
  { label: "累计阅读", value: "3.6 亿+" },
  { label: "原创栏目", value: "9 个" },
  { label: "全网粉丝", value: "120 万+" },
];

export const navLinks = [
  { key: "home", name: "首页", href: "#home" },
  { key: "hot", name: "今日热榜", href: "#hot" },
  { key: "columns", name: "栏目矩阵", href: "#columns" },
  { key: "featured", name: "深度追踪", href: "#featured" },
  { key: "about", name: "关于黑屋", href: "#about" },
  { key: "faq", name: "常见问题", href: "#faq" },
];

export const hotItems: HotItem[] = [
  { rank: 1, title: "国产音综进入「舞台卷」时代，谁的声量靠内容撑住", tag: "沸", heat: "528.4万", trend: "up" },
  { rank: 2, title: "暑期档片单背后：宣发预算流向哪里，口碑就定在哪里", tag: "热", heat: "417.9万", trend: "up" },
  { rank: 3, title: "「体验型消费」火了，年轻人在为什么样的场景买单", tag: "新", heat: "356.2万", trend: "up" },
  { rank: 4, title: "网剧短句化之后，长内容的留存靠什么", tag: "热", heat: "289.6万", trend: "flat" },
  { rank: 5, title: "从物料泄露到正式官宣：一场发布会如何制造期待", tag: "热", heat: "238.1万", trend: "up" },
  { rank: 6, title: "偶像选秀十年：从造星工厂到内容厂牌的重构", tag: "新", heat: "196.8万", trend: "down" },
  { rank: 7, title: "综艺嘉宾「人设管理」术，是被误解还是真有用", tag: "热", heat: "172.4万", trend: "flat" },
  { rank: 8, title: "数据之外的讨论场：真实声量与算法热度的差距", tag: "新", heat: "141.5万", trend: "up" },
  { rank: 9, title: "老IP翻新重映，情怀之外观众还想看到什么", tag: "热", heat: "118.7万", trend: "down" },
  { rank: 10, title: "幕后工种开始被看见：综艺导演、剪辑师与选角故事", tag: "新", heat: "96.2万", trend: "up" },
];

export const categories: Category[] = [
  { key: "news", name: "娱乐前线", desc: "影视、综艺与演出市场的最新动向与热搜解读。", count: 386 },
  { key: "behind", name: "背后故事", desc: "聚焦项目与人物被忽略的创作过程与来龙去脉。", count: 142 },
  { key: "industry", name: "行业观察", desc: "从平台、资本与内容供给端看娱乐产业的变与不变。", count: 209 },
  { key: "culture", name: "文化解读", desc: "把热点放回社会情绪与青年文化语境里拆开看。", count: 173 },
];

export const articles: Article[] = [
  {
    id: "a1",
    categoryKey: "news",
    category: "娱乐前线",
    title: "一场音综决赛的「剧本感」争议，争议点到底在不在舞台",
    excerpt: "当灯光、舞美与选曲都被推到天花板级别，观众争论的焦点却悄悄转向了结果背后的「安排」。我们顺着制作链路，还原一场决赛从彩排到播出之间发生了什么。",
    date: "2026-09-08",
    views: "48.2万",
    minutes: 8,
    tag: "综艺",
    image: "https://readdy.ai/api/search-image?query=dark%20editorial%20music%20stage%20with%20dramatic%20warm%20spotlight%20and%20haze%2C%20crowd%20silhouettes%2C%20deep%20charcoal%20tones%20with%20subtle%20coral%20red%20light%2C%20cinematic%20behind%20the%20scenes%20mood%2C%20high%20detail%20photo&width=900&height=600&seq=chigua-a1&orientation=landscape",
  },
  {
    id: "a2",
    categoryKey: "behind",
    category: "背后故事",
    title: "一场发布会如何「被泄露」：热度的剧本早就写在流程里",
    excerpt: "物料提前流出、词条提前预埋、发布时间精确到秒——我们梳理了近二十场官宣事件的公开流程，试图理解「恰到好处的意外」背后到底有没有巧思。",
    date: "2026-09-06",
    views: "36.7万",
    minutes: 6,
    tag: "宣发",
    image: "https://readdy.ai/api/search-image?query=dark%20stage%20press%20launch%20backstage%20with%20warm%20amber%20and%20green%20accent%20lights%2C%20camera%20silhouette%20and%20television%20monitors%2C%20nocturnal%20media%20room%20mood%2C%20deep%20shadow%20editorial%20photography&width=900&height=600&seq=chigua-a2&orientation=landscape",
  },
  {
    id: "a3",
    categoryKey: "industry",
    category: "行业观察",
    title: "长剧回暖的这两年，平台到底在赌什么",
    excerpt: "从单集注水到精品化回归，从分账到「剧场化」运营。我们用几组公开数据，拆解长内容重新被重视的真实原因，以及它还能走多远。",
    date: "2026-09-04",
    views: "51.9万",
    minutes: 10,
    tag: "平台",
    image: "https://readdy.ai/api/search-image?query=dark%20cinematic%20film%20set%20with%20director%20chair%20and%20clapperboard%2C%20warm%20coral%20practical%20lighting%2C%20theater%20curtain%20in%20deep%20shadow%2C%20moody%20film%20industry%20photography&width=900&height=600&seq=chigua-a3&orientation=landscape",
  },
  {
    id: "a4",
    categoryKey: "culture",
    category: "文化解读",
    title: "「体验型消费」背后的年轻人：要的从来不是东西，是瞬间",
    excerpt: "演唱会、沉浸式展览与快闪市集持续刷屏。当「体验」本身成为被消费的对象，我们在意的其实是情感被确认、记忆被制造的那个过程。",
    date: "2026-09-02",
    views: "29.3万",
    minutes: 5,
    tag: "青年文化",
    image: "https://readdy.ai/api/search-image?query=dark%20concert%20crowd%20with%20phone%20lights%20and%20warm%20green%2Fcoral%20stage%20glow%2C%20immersive%20experience%20mood%2C%20energetic%20young%20audience%20silhouettes%2C%20editorial%20night%20photography&width=900&height=600&seq=chigua-a4&orientation=landscape",
  },
  {
    id: "a5",
    categoryKey: "behind",
    category: "背后故事",
    title: "幕后工种被看见的一年：剪辑师、选角与综艺导演的日常",
    excerpt: "「一档节目好看」是无数被隐去的名字共同完成的结果。我们走进几个幕后团队，记录下那些不上热搜、却决定内容质感的工作瞬间。",
    date: "2026-08-30",
    views: "22.8万",
    minutes: 9,
    tag: "幕后",
    image: "https://readdy.ai/api/search-image?query=dark%20editing%20room%20with%20multiple%20monitors%20and%20color%20grading%20timeline%2C%20warm%20desk%20lamp%20amber%20light%2C%20deep%20green%20plant%20shadow%2C%20focused%20creative%20workspace%2C%20moody%20photography&width=900&height=600&seq=chigua-a5&orientation=landscape",
  },
  {
    id: "a6",
    categoryKey: "industry",
    category: "行业观察",
    title: "偶像内容十年：从「造星」到「内容厂牌」的转身",
    excerpt: "当年围着舞台转的注意力，如今散落在剧集、直播与短视频里。当偶像经纪学会把内容当作品经营，真正的竞争才刚开始。",
    date: "2026-08-26",
    views: "40.6万",
    minutes: 11,
    tag: "偶像",
    image: "https://readdy.ai/api/search-image?query=dark%20music%20studio%20with%20microphone%20and%20neon%20coral%20ring%20light%2C%20idol%20training%20room%20mood%2C%20deep%20charcoal%20with%20green%20and%20red%20accent%20glow%2C%20modern%20creative%20space%20photography&width=900&height=600&seq=chigua-a6&orientation=landscape",
  },
  {
    id: "a7",
    categoryKey: "culture",
    category: "文化解读",
    title: "老IP翻新成风，情怀以外观众到底在期待什么",
    excerpt: "重映、续集与经典重塑接连上桌。当「爷青回」的热度褪去，真正决定口碑的，往往是作品是否接住了新一代观众的审美与情绪。",
    date: "2026-08-22",
    views: "18.9万",
    minutes: 7,
    tag: "怀旧",
    image: "https://readdy.ai/api/search-image?query=dark%20vintage%20cinema%20with%20projector%20light%20beam%20and%20film%20strips%2C%20warm%20amber%20toned%20retro%20atmosphere%2C%20dust%20particles%20in%20light%2C%20nostalgic%20moody%20photography&width=900&height=600&seq=chigua-a7&orientation=landscape",
  },
  {
    id: "a8",
    categoryKey: "news",
    category: "娱乐前线",
    title: "从热搜到反热搜：一场公共讨论如何完成「破圈」",
    excerpt: "当话题从粉丝圈层流向大众场域，讨论的重心往往会经历多次漂移。我们观察了几起典型事件，梳理情绪与理性来回拉锯的真实过程。",
    date: "2026-08-18",
    views: "31.5万",
    minutes: 6,
    tag: "热搜",
    image: "https://readdy.ai/api/search-image?query=dark%20abstract%20news%20feed%20with%20glowing%20text%20bubbles%20and%20search%20light%2C%20warm%20coral%20and%20green%20digital%20glow%2C%20deep%20black%20background%2C%20social%20media%20concept%20art&width=900&height=600&seq=chigua-a8&orientation=landscape",
  },
];

export const storyHighlights: Story[] = [
  {
    id: "s1",
    kicker: "深度专题 · 观察类",
    title: "注意力经济下半场：谁还在为「真实」付钱",
    excerpt: "算法把信息喂到嘴边，热搜把情绪推到顶点。当「看到」变得越来越容易，「相信」反而成了一种稀缺能力。我们从内容消费的底层逻辑出发，聊了聊在这个信息过剩的时代，真实感和信任感为什么如此值钱，也如此难造。",
    date: "2026-09-07",
    minutes: 16,
    reading: "2.4万收藏",
    image: "https://readdy.ai/api/search-image?query=dark%20editorial%20concept%20of%20overload%20of%20news%20glowing%20screens%20stacked%20in%20shadow%2C%20a%20single%20warm%20coral%20light%20through%20the%20darkness%20symbolizing%20truth%2C%20deep%20charcoal%20tone%2C%20high%20contrast%20conceptual%20photography&width=1200&height=750&seq=chigua-story1&orientation=landscape",
  },
  {
    id: "s2",
    kicker: "深度专题 · 行业向",
    title: "一场演唱会如何从「舞台」变成「内容事件」",
    excerpt: "票务、舞美、直播、二创与售后——现代演唱会早已不只是三小时的现场。我们跟访了幕后团队，拆解一场演出如何被策划成可供反复消费的内容事件，也谈谈这个过程中，观众的体验被如何重新定义。",
    date: "2026-09-01",
    minutes: 14,
    reading: "1.8万收藏",
    image: "https://readdy.ai/api/search-image?query=dark%20concert%20stage%20from%20behind%20with%20warm%20coral%20and%20green%20beams%20of%20light%2C%20empty%20auditorium%20in%20shadow%2C%20golden%20haze%2C%20epic%20live%20show%20behind%20the%20scenes%20photography&width=1200&height=750&seq=chigua-story2&orientation=landscape",
  },
  {
    id: "s3",
    kicker: "深度专题 · 人物向",
    title: "不做流量的「提线木偶」：内容主理人自白",
    excerpt: "我们和几位在综艺、剧集与直播一线的内容主理人聊了聊。在热度与自我表达之间，他们如何做出选择，又如何在爆款焦虑里守住「把内容当作品」的初心。这些没有台词的独白，或许比任何热搜都更接近行业的底色。",
    date: "2026-08-24",
    minutes: 12,
    reading: "1.2万收藏",
    image: "https://readdy.ai/api/search-image?query=dark%20portrait%20silhouette%20of%20content%20creator%20in%20front%20of%20warm%20amber%20window%20light%2C%20deep%20shadow%20editorial%20interview%20mood%2C%20intimate%20and%20introspective%2C%20cinematic%20photography&width=1200&height=750&seq=chigua-story3&orientation=landscape",
  },
];

export const faqs: Faq[] = [
  {
    q: "吃瓜黑屋的内容是怎么来的？",
    a: "我们的内容以公开报道、平台数据、公开的行业资料以及一线从业者的长期观察为基础，再经编辑团队核实与交叉比对后成稿。对于无法确证的信息，我们会在文中明确标注「有待核实」，不做没有依据的断言。",
  },
  {
    q: "你们会发布未经证实的小道消息吗？",
    a: "不会。我们不追逐、也不传播未经证实的传闻。我们更愿意把流量聚光灯下的现象，放回创作过程、行业逻辑与社会情绪里做梳理——这才是「把瓜吃透」的真正方式。",
  },
  {
    q: "如何区分吃瓜黑屋的不同栏目？",
    a: "你可以用四个维度快速定位：想看影视综艺热点进「娱乐前线」；想了解项目背后的来龙去脉进「背后故事」；想读平台与产业的理性分析进「行业观察」；想把热点放进文化语境里理解，就去「文化解读」。",
  },
  {
    q: "我想转载黑屋的文章，需要怎么做？",
    a: "非常欢迎在注明出处并保留原文链接的前提下进行合理转载。商用或大规模转载请联系我们的编辑部授权，我们会在邮件中说明具体规范。",
  },
  {
    q: "如何订阅深度专题的更新？",
    a: "在页面底部填写邮箱订阅即可。每周我们会精选 1–2 篇深度专题与当周热榜解读，直接发送到你的邮箱，不会用推送打扰你。",
  },
  {
    q: "我对某个选题有线索或投稿，如何联系？",
    a: "欢迎通过页面底部的联系方式发来线索与选题建议。我们会认真阅读每一封来信，若选题符合栏目定位，编辑会主动与你进一步沟通。",
  },
];

export const voices: Voice[] = [
  {
    name: "凌晨的瓜友",
    role: "追综艺十年",
    text: "看了很多年娱乐号，黑屋是少数会认真讲「为什么」的。每次看完一篇行业观察，再看热搜都觉得清楚了很多。",
  },
  {
    name: "一只电子羊",
    role: "内容从业者",
    text: "做内容的人最怕被流量裹挟。黑屋把「幕后工种被看见」写成专题的时候，我几乎是红着眼睛看完的，太懂那种感受了。",
  },
  {
    name: "甜筒不化",
    role: "剧集爱好者",
    text: "长剧回暖那篇数据很扎实，逻辑也顺。不是情绪化的吐槽，是把一件事掰开揉碎讲明白，看完会被圈粉的那种。",
  },
  {
    name: "猫打瞌睡",
    role: "吃瓜爱好者",
    text: "第一次进来以为只是又一个八卦号，点开深度专题才发现内容是有分量的。会常来，也真的会分享给朋友。",
  },
];

export const memberships = [
  { title: "采编团队", desc: "来自影视、媒体与数据研究的复合背景，坚持一手观察与交叉核实。" },
  { title: "内容原则", desc: "只讲有依据的事，标注待证实的部分，不靠耸动标题透支信任。" },
  { title: "立场声明", desc: "不追热点内耗，不消费当事人，把讨论拉回作品与行业本身。" },
];